<circle-progress
  *ngIf="cs.isBrowser"
  [percent]="percent"
  [radius]="UPLOAD_PROGRESS.CIRCLE.RADIUS"
  [outerStrokeWidth]="UPLOAD_PROGRESS.CIRCLE.OUTER_STROKE_WIDTH"
  [innerStrokeWidth]="UPLOAD_PROGRESS.CIRCLE.INNER_STROKE_WIDTH"
  [outerStrokeColor]="outerStrokeColor"
  [innerStrokeColor]="UPLOAD_PROGRESS.CIRCLE.INNER_STROKE"
  [animation]="false"
  [animationDuration]="UPLOAD_PROGRESS.CIRCLE.ANIMATION_DURATION"
  [showSubtitle]="false"
  [backgroundPadding]="UPLOAD_PROGRESS.CIRCLE.BACKGROUND_PADDING"
  [titleFontSize]="UPLOAD_PROGRESS.CIRCLE.TITLE_FONT_SIZE"
  [titleColor]="UPLOAD_PROGRESS.CIRCLE.TITLE"
  [unitsColor]="UPLOAD_PROGRESS.CIRCLE.UNITS"
  [space]="UPLOAD_PROGRESS.CIRCLE.SPACE"
></circle-progress>
